<template>
  <div>
    <appHeader></appHeader>
    <div class="container-fluid admin-send-email-to-user">
      <div class="row">
        <div class="col-md-3 col-sm-12 pr-0 dark-bg">
          <appAdminSidebar></appAdminSidebar>
        </div>
        <transition appear name="fade">
          <div class="col-md-9 p-4">
            <h4>Add Points</h4>
            <hr />
            <appAddPointsStartWith></appAddPointsStartWith>
            <router-view />
          </div>
        </transition>
      </div>
    </div>
    <appFooter></appFooter>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import AdminSidebar from "@/views/admin/AdminSidebar.vue";
import AddPointsStartWith from "@/views/admin/users/addPoints/AddPointsStartWith.vue";
import { mapState } from "vuex";

export default {
  name: "AddPoints",

  props: {
    activeMenuItem: String,
    activeMenu: String,
  },

  components: {
    appHeader: Header,
    appFooter: Footer,
    appAdminSidebar: AdminSidebar,
    appAddPointsStartWith: AddPointsStartWith,
  },

  data() {
    return {};
  },

  methods: {
    setActiveMenuItem: function () {
      this.$store.dispatch("adminSidebar/setActive", {
        activeMenuItem: this.activeMenuItem
          ? this.activeMenuItem
          : "usersAddPoints",
        activeMenu: this.activeMenu ? this.activeMenu : "users",
      });
    },
  },

  created() {
    this.setActiveMenuItem();
  },
};
</script>

<style lang="scss" scoped>
.admin-send-email-to-user {
  margin: -14px 0 0 0;
  .badge {
    font-size: 0.8rem;
    padding: 6px 0px;
    border-radius: $border-radius-sm;
  }
}
.align-right {
  text-align: right;
}

.bold-text {
  font-weight: bold;
}

.display-flex {
  display: flex;
}

.marginAll {
  margin: 10px;
}
</style>
